// extracted by mini-css-extract-plugin
module.exports = {"item":"jb","dark":"jc","light":"jd","toggle":"je"};